<template>
    <div v-if="type == 2" class="preview-box" v-loading="loading" element-loading-background="rgba(255, 255, 255, 1)">
        <div v-for="(img, index) in images" :key="index" :style="{ 'z-index': index >= imgLayer ? index + 1 : index }"
            style="position: absolute; left: 0; top: 0; width: 100%; height: 100%">
            <img :src="img" alt="" />
        </div>

        <div :id="`three-${id}`" :style="{ 'z-index': imgLayer }"
            style="position: absolute; left: 0; top: 0; width: 1600px; height: 1600px"></div>
    </div>
    <div v-else-if="type == 3" class="preview-box">
        <div :id="`three-${id}`" :style="{ width: width + 'px', height: height + 'px' }"></div>
    </div>

    <div v-else-if="type == 4 && psdData?.width" :style="{ width: width + 'px', height: height + 'px' }"
        v-loading="loading" element-loading-background="rgba(255, 255, 255, 1)">
        <canvas :id="`psdCanvas-${id}`" style="transform-origin: left top;" :style="{
            'margin-left': `${psdSize.left}px`,
            'margin-top': `${psdSize.top}px`,
            transform: `scale(${psdSize.scaleX}, ${psdSize.scaleY})`,
        }"></canvas>
    </div>
</template>
<script>
import renderModel from "@/utils/renderModel.js";
import SmartObjectRenderer from '@/utils/SmartObject.js'
export default {
    props: {
        value: {
            type: [Object],
        },
        images: {
            type: Array,
        },
        imgLayer: {
            type: Number,
        },
        modelParams: {
            type: Object,
            default: () => { },
        },
        materialList: {
            type: Object,
            default: () => { },
        },
        modelUrl: {
            type: Array,
        },
        id: {
            type: [String, Number],
        },
        width: {
            type: Number,
            default: 600,
        },
        height: {
            type: Number,
            default: 600,
        },
        type: {
            type: Number,
            default: 3,
        },
    },

    data() {
        return {
            modelApi: {},
            loading: true,
            psdCanvas: null,
            imgObject: {},
            psdData: {},
            pathBoundsCache: new Map(), // 路径边界缓存
            bmList: {
                'normal': 'source-over',
                'pass through': 'source-over',
                'multiply': 'multiply',
                'soft light': 'soft-light',
                'linear burn': 'color-burn'
            },
        };
    },
    watch: {
        images: {
            handler(val) { },
        },
    },
    computed: {
        psdSize() {
            const psdData = this.psdData
            const maxSide = Math.max(psdData?.width, psdData?.height);
            const scale = this.width / maxSide;
            const scaleX = scale
            const scaleY = scale
            const left = (this.width - psdData?.width * scale) / 2
            const top = (this.height - psdData?.height * scale) / 2
            return {
                scaleX,
                scaleY,
                left,
                top,
            }
        }
    },
    methods: {
        moveCamera(params) {
            this.modelApi.moveCamera(params);
        },

        async setMapTexture(params) {
            // console.log(params, this.id)
            return this.modelApi.setMap(params);
        },

        async switchModelByName(params) {
            let parts = params.parts;
            for (let part of parts) {
                await this.modelApi.switchModelByName({
                    name: part,
                    model_url: params.model_url,
                });
            }
        },

        async switchModel(params) {
            await this.modelApi.switchModel(params);
            await new Promise((resolve) => setTimeout(resolve, 200));
            return this.getModelImage();
        },


        async setModelColorMutlipe(params) {
            try {
                this.modelApi.setModelColorMutlipe(params);
                await new Promise((resolve) => setTimeout(resolve, 100));
                return true;
            } catch (error) {
                // 捕获并抛出错误
                throw error;
            }
        },


        async setModelColor(params) {
            try {
                await this.modelApi.setModelColor(params);
                await new Promise((resolve) => setTimeout(resolve, 100));
                return true;
            } catch (error) {
                // 捕获并抛出错误
                throw error;
            }
        },

        async getModelImage() {
            let img = await this.modelApi.toDataURL("image/png");
            return img;
        },

        async setNormalMap(params) {
            await this.modelApi.setNormalMap(params);
        },

        async importScene(json) {
            await this.modelApi.importScene(json);
        },

        async init() {
            // 直接初始化 renderModel 实例
            this.modelApi = new renderModel(`#three-${this.id}`);
            // 构建初始化参数
            const params = {
                modelParams: this.modelParams,
                materialList: this.materialList,
                targetSize: 2,
                fileParams: Array.isArray(this.modelUrl)
                    ? this.modelUrl
                    : [this.modelUrl],
            };

            // 检查文件参数是否有效
            if (!params.fileParams[0] || !params.fileParams[0].url) {
                this.loading = false;
                return true;
            }

            try {
                // 延迟 100ms 后初始化模型
                await new Promise((resolve) => setTimeout(resolve, 100));
                await this.modelApi.init(params);
            } catch (error) {
                // 处理初始化过程中的错误
                console.error("模型初始化失败:", error);
                throw error;
            } finally {
                // 无论初始化成功与否，都将 loading 状态设置为 false
                this.loading = false;
            }

            return true;
        },

        async psdAction(func, params) {
            try {
                if (!this[func]) return
                return await this[func](params)
            } catch (error) {
                console.error(error)
            }
        },


        buildPsdValue() {
            for (const layer of this.psdData.psdDatas) {
                if (layer.IMG) {
                    this.imgObject[layer.N] = layer.IMG;
                } else if (layer.CL) {
                    const SmartObject = layer.CL.find(c => c.T == 'SmartObject')
                    if (SmartObject.IMG) {
                        this.imgObject[layer.N] = SmartObject.IMG
                    }
                }
            }
        },




        async createTextureByFace({ texture, name }) {
            try {
                let img = texture
                const layerData = this.psdData.psdDatas.find(item => item.N === name);
                const value = layerData.CL ? layerData.CL.find((i) => i.T == 'SmartObject') : layerData
                if (value.M) {
                    const render = new SmartObjectRenderer({ size: value.WT, bg_img: value.IMG })
                    img = await render.setTexture({ imageUrl: texture, meshPoints: value.PS, customMatrix: value.M, width: value.OS[0], height: value.OS[1] })
                }
                return img
            } catch (error) {
                console.log(error)
            }
        },


        initPsdCavans(value) {
            this.psdData = value
            this.psdCanvas = new fabric.Canvas(`psdCanvas-${this.id}`, {
                fireRightClick: true,
                stopContextMenu: true,
                controlsAboveOverlay: true,
                imageSmoothingEnabled: false,
                centeredRotation: true,
                preserveObjectStacking: true,
                selection: false,
                backgroundColor: '',
                width: this.psdData.width,
                height: this.psdData.height,
                hoverCursor: 'default',  // 鼠标悬停在对象上时的样式
                moveCursor: 'move',      // 移动对象时的样式
                defaultCursor: 'default' // 默认样式
            });
            this.buildPsdValue();
        },


        async drawAllLayers(value) {
            try {
                this.psdCanvas.clear()
                await this.$nextTick()
                for (let item of value) {
                    await this.drawCanvas(item)
                }
                this.psdCanvas.renderAll()
                const img = this.psdCanvas.toDataURL()
                return img
            } catch (error) {
                console.log("🚀 ~ error:", error)
            }
        },

        clearPsdCanvas() {
            this.psdCanvas.clear()
        },

        loadFabricImage(url) {
            return new Promise((resolve, reject) => {
                fabric.Image.fromURL(url, (imgObj) => {
                    resolve(imgObj)
                }, {
                    crossOrigin: 'anonymous'
                })
            })
        },

        async drawCanvas(item) {
            try {
                const canvas = this.psdCanvas
                const layers = item.T === 'Group' ? item.CL || [] : [item];
                for (const layer of layers) {
                    const name = layer.T === 'SmartObject' ? item.N : layer.N;
                    if (layer.IMG) {
                        const PATH = item.MK?.path || '';
                        const { X, Y, O, WT } = layer;
                        const blendMode = this.bmList[layer.BM] || 'source-over';
                        let imgObj = await this.loadFabricImage(layer.IMG)
                        imgObj.set({
                            name: name,
                            selectable: false,
                            left: X,
                            top: Y,
                            opacity: O,
                            globalCompositeOperation: blendMode,
                            hasControls: false,
                            hasBorders: false,
                        });
                        if (PATH) {
                            const clipPath = new fabric.Path(PATH, {
                                fill: 'transparent',
                                objectCaching: false,
                                absolutePositioned: true,
                            });
                            // 获取 path 的宽高
                            const { left, top } = clipPath.getBoundingRect();
                            clipPath.set({
                                left: item.MK.left + left,
                                top: item.MK.top + top,
                            })
                            imgObj.clipPath = clipPath;
                        }
                        canvas.add(imgObj)
                    }
                }
            } catch (error) {
                console.error('Error processing layer:', error);
            }
        },

        // 解析SVG路径并获取边界
        parseSVGPath(pathString) {
            if (!pathString) return null;

            const commands = pathString.match(/[A-Za-z][^A-Za-z]*/g);
            if (!commands) return null;

            let minX = Infinity, minY = Infinity;
            let maxX = -Infinity, maxY = -Infinity;
            let currentX = 0, currentY = 0;

            for (const command of commands) {
                const type = command[0];
                const args = command.slice(1).trim().split(/[\s,]+/).map(Number);

                switch (type.toUpperCase()) {
                    case 'M': // MoveTo
                        currentX = args[0] || 0;
                        currentY = args[1] || 0;
                        minX = Math.min(minX, currentX);
                        minY = Math.min(minY, currentY);
                        maxX = Math.max(maxX, currentX);
                        maxY = Math.max(maxY, currentY);
                        break;
                    case 'L': // LineTo
                        currentX = args[0] || currentX;
                        currentY = args[1] || currentY;
                        minX = Math.min(minX, currentX);
                        minY = Math.min(minY, currentY);
                        maxX = Math.max(maxX, currentX);
                        maxY = Math.max(maxY, currentY);
                        break;
                    case 'C': // Cubic Bezier
                        for (let i = 0; i < args.length; i += 2) {
                            const x = args[i];
                            const y = args[i + 1];
                            minX = Math.min(minX, x, currentX);
                            minY = Math.min(minY, y, currentY);
                            maxX = Math.max(maxX, x, currentX);
                            maxY = Math.max(maxY, y, currentY);
                        }
                        currentX = args[4] || currentX;
                        currentY = args[5] || currentY;
                        break;
                    case 'Z': // ClosePath
                        break;
                }
            }

            return {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY
            };
        },

        // 获取路径边界（带缓存）
        getPathBounds(pathString) {
            if (this.pathBoundsCache.has(pathString)) {
                return this.pathBoundsCache.get(pathString);
            }

            const bounds = this.parseSVGPath(pathString);
            if (bounds) {
                this.pathBoundsCache.set(pathString, bounds);
            }

            return bounds;
        },

        // 应用裁剪路径
        applyClipPath(ctx, pathString, clipMask) {
            if (!pathString) return false;

            try {
                const path = new Path2D(pathString);
                const bounds = this.getPathBounds(pathString);

                if (!bounds) return false;

                // 创建裁剪区域
                ctx.save();
                ctx.translate(clipMask.left, clipMask.top);
                ctx.scale(
                    clipMask.width / bounds.width,
                    clipMask.height / bounds.height
                );
                ctx.translate(-bounds.x, -bounds.y);
                ctx.clip(path);
                ctx.restore();

                return true;
            } catch (error) {
                console.error('应用裁剪路径失败:', error);
                return false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.preview-box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 600px;
    height: 600px;

    img {
        width: inherit;
        height: inherit;
    }
}

.effect-three {
    position: absolute;
    left: 100%;
    width: 600px;
    height: 600px;
}
</style>
